import { schemaTypes } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import { changeVehicle } from "./historyReport/historyReport";
import moment from "moment";

const processData = (resp, callback) => {
  const historyData = (resp || []).map((item) => ({
    vehicleno: item.vehicleno,
    deviceno: item.deviceno,
    date: item.date,
    totalDistance:
      item.totalDistance != null
        ? parseFloat(item.totalDistance.toFixed(2))
        : 0,
  }));
  callback(historyData);
};

const getHistory = (schema, data, store) => {
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;

  data.vehicle =
    window.selectedItems && window.selectedItems.length
      ? window.selectedItems
      : window.itemClicked
      ? window.selectedVehicles
      : data.vehicle || [];

  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }

  const starttime = moment(data.starttime).startOf("day").valueOf();
  const endtime = moment(data.endtime).endOf("day").valueOf();

  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }

  if (endtime - starttime > 1000 * 60 * 60 * 24 * 31) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 31 days",
        content: "You can't select date range of more than 31 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }

  if (window.setReportWindowTabBusy) {
    window.setReportWindowTabBusy(schema, true);
  }
  if (schema.content[0].ref) {
    schema.content[0].ref.setBusy(true);
    saveState = schema.content[0].ref.props.saveState;
    tableStateData = [
      schema.content[0].ref.state,
      schema.content[0].ref.props.schemaKey,
      schema.content[0].ref.props.data,
    ];
  }

  const handleSuccess = (resp) => {
    window.dataForAll = resp;
    if (window.setReportWindowTabBusy) {
      window.setReportWindowTabBusy(schema, false);
    }
    processData(resp, (tableData) => {
      schema.finalData = tableData;
      if (tableStateData && tableStateData[0]) {
        tableStateData[0].body = tableData;
        tableStateData[0].busy = false;
        saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
      }
      if (schema.content[0].ref) {
        schema.content[0].ref.setData(tableData);
        schema.content[0].ref.setBusy(false);
      }
    });
  };

  const body = {
    vehicleid: data.vehicle.map((item) => parseInt(item.id, 10)),
    starttime,
    endtime,
  };

  ReportAPIs.getEbikeReport(body).then(handleSuccess, () => {
    handleSuccess([]);
  });
};

const download = (schema, data, store) => {
  const filterdData = schema.content[0].ref.state.body;
  if (!filterdData.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "No data Available",
        content: "No data Available",
        createAt: Date.now(),
        autoClose: 8000,
        showError: true,
      },
    });
    return;
  }

  schema.finalData = filterdData;
  const heads = schema.content[0].head;
  const newData = filterdData.map((row) => {
    const tempdata = {};
    heads.forEach((head) => {
      if (head.key in row) {
        tempdata[head.name] = row[head.key];
      }
    });
    return tempdata;
  });

  setTimeout(() => {
    JSONToCSVConvertor(newData, "ebike_report", false);
  }, 500);
};

const schema = {
  key: "ebike_report",
  name: "E-Bike Report",
  finalData: null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: (window.selectedVehicles || []).map((i) => i.id),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: true,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now(),
      hideTime: true,
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get E-Bike Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        { key: "vehicleno", name: "Vehicle No" },
        { key: "deviceno", name: "Device No" },
        { key: "date", name: "Date" },
        { key: "totalDistance", name: "Total Distance (km)" },
      ],
    },
  ],
};

export default schema;
